export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
